import React from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { FaCopy, FaExternalLinkAlt } from "react-icons/fa";

import { productAction } from "@redux/modules";

import "./styles.scss";

/**
 * Ayrıcalık ürününde üyeye atanmış kodu gösterir: kopyala butonu + (açıklamada
 * bağlantı varsa) "Partner sitesinde kullan" butonu. Partner bağlantısı doğrudan
 * <a target="_blank"> ile açılır (popup engelleyiciye takılmaz); tıklama ayrıca
 * backend'e loglanır.
 */
const PrivilegeCodeBox = ({ productId, code, partnerUrl, compact = false }) => {
  const dispatch = useDispatch();

  const handleCopy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!code) return;

    const done = () => toast.success("Kodunuz kopyalandı!");
    if (navigator.clipboard?.writeText) {
      navigator.clipboard
        .writeText(code)
        .then(done)
        .catch(() => toast.error("Kopyalama başarısız oldu."));
    } else {
      // Eski tarayıcılar / http ortamı için yedek yöntem.
      const textarea = document.createElement("textarea");
      textarea.value = code;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        done();
      } catch (err) {
        toast.error("Kopyalama başarısız oldu.");
      }
      document.body.removeChild(textarea);
    }
  };

  const handlePartnerClick = (e) => {
    e.stopPropagation();
    dispatch(productAction.logPrivilegeRedirect(productId));
  };

  if (!code) return null;

  return (
    <div className={`privilege-code-box ${compact ? "is-compact" : ""}`}>
      <span className="privilege-code-label">Ayrıcalık kodunuz</span>
      <div className="privilege-code-row">
        <code className="privilege-code-value">{code}</code>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm privilege-code-copy"
          onClick={handleCopy}
          aria-label="Kodu kopyala"
        >
          <FaCopy className="me-1" />
          Kopyala
        </button>
      </div>
      {partnerUrl && (
        <a
          href={partnerUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-green text-white rounded-pill privilege-partner-btn"
          onClick={handlePartnerClick}
        >
          Partner sitesinde kullan
          <FaExternalLinkAlt className="ms-2" />
        </a>
      )}
    </div>
  );
};

export default PrivilegeCodeBox;
